import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ValidatorFn, FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';

//import services
import { GeneralService } from '../../../../services/general.service';
import { ServicingService } from '../../../../services/servicing.service';
import { ProjectService } from '../../../../services/project.service';
import { exit } from 'process';
declare var $: any;


@Component({
  selector: 'app-project_create_edit',
  templateUrl: './project_create_edit.component.html',
  styleUrls: ['./project_create_edit.component.css']
})
export class ProjectCreateEditComponent implements OnInit {

  @Input() ID: string;
  @Input() lang;
  @Input() data;
  @Input() record;

  @ViewChild('imagePreviewRef') imagePreviewRef: ElementRef;
  frequencyConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string = "Create Project";
  maintenance_plans: any;
  notification_time: any;
  form_data: any;
  app_emp_id: any;
  generalLang: any;
  mode: string;
  show: any;

  imageLink: any;
  redirect1: any;

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  customerList = []
  projectList = []
  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private projectService: ProjectService,
    private router: Router,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.FormBuild();
    this.getData();
    this.fileDesign();

    if(this.ID){
      this.modalTitle = "Edit Project";
      console.log("======== Record ========")
      console.log(this.record)
      this.FormBuildUpdate();
    }

    for(var customer of this.data.customer){
      let data = {
        "item_id" : customer.customersId,
        "item_name" : customer.bussines_name,
      }
      this.customerList.push(data)

      if(this.ID && customer.customersId == this.record.customer_id){
        this.selectedItems.push(data)
      }

    }

    var tempProj = [];
    for(var project in this.data.project_class){
      tempProj.push(this.data.project_class[project])
    }    
    this.projectList = tempProj
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  getProjectVal(){
    let category = $('#class_id').find('option:selected').attr('data-category');
    $('#class_category').val(category);
    this.createForm.patchValue({class_category:category})
  }

  offer_link(): FormArray {
    return this.createForm.get('offer_link') as FormArray;
  };
  timetable_link(): FormArray {
    return this.createForm.get('timetable_link') as FormArray;
  };

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }

  addOfferAttachment(): void {
    this.offer_link().push(this.newAttachment());
  }

  addAttachment(): void {
    this.timetable_link().push(this.newAttachment());
  }

  removeAttachment(i: number) {
    this.timetable_link().removeAt(i);
  }

  removeOfferAttachment(i: number) {
    this.offer_link().removeAt(i);
  }  

  timetable_link_uploaded(): FormArray {
    return this.createForm.get('timetable_link_uploaded') as FormArray;
  };

  offer_link_uploaded(): FormArray {
    return this.createForm.get('offer_link_uploaded') as FormArray;
  };  

  removeOfferAttachmentUploaded(i: number) {
    this.offer_link_uploaded().removeAt(i);
  }  

  removeAttachmentUploaded(i: number) {
    this.timetable_link_uploaded().removeAt(i);
  }
  
  public selectAttachment(event: any, index) {

    this.createForm.value.timetable_link[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      
      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
          this.createForm.value.timetable_link[index].link = {'name': file.name, 'image': reader.result};
      };
    }
    
  }

  FormBuild(): void {
    this.createForm = this.formBuilder.group({
      id:[],
      code: ['', [Validators.required]],
      title: ['', [Validators.required]],
      customer_id: ['', [Validators.required]],
      emp_id: ['', [Validators.required]],
      amount: ['', [Validators.required]],
      hours: ['', [Validators.required]],
      start_date: ['', [Validators.required]],
      d_date: ['', [Validators.required]],
      // offer: ['', [Validators.required]],
      // contact: ['', [Validators.required]],
      class_id: ['', [Validators.required]],
      class_category: ['', [Validators.required]],
      timetable_link: this.formBuilder.array([this.newAttachment()]),
      timetable_link_uploaded: this.formBuilder.array([]),

      offer_link: this.formBuilder.array([this.newAttachment()]),
      offer_link_uploaded: this.formBuilder.array([]),      
      action: 'update',
    });

    setTimeout(() => this.fileDesign(), 10);

    this.timetable_link().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });    

  }

  fileDesign(){
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }  

  FormBuildUpdate(): void {

    this.createForm.patchValue({
      code: this.record.code,
      title: this.record.title,
      // customer_id: this.record.customer_id,
      emp_id: this.record.emp_id,
      amount: this.record.amount,
      hours: this.record.hours,
      start_date: this.record.start_date,
      d_date: this.record.div_date,
      class_id: this.record.class_id,
      class_category: this.record.class_category,
      id:this.ID,
      action: 'update',

    });
    
    // set value for project category
    const that = this;
    setTimeout(function(){
      that.getProjectVal()
    },1000)      

    let offers = this.record.offer.split(',');
    if(this.record.offer) {
      for (const offer of offers) {
        this.offer_link_uploaded().push(new FormControl(offer.split('/').pop()));
      }
    }    

    let contacts = this.record.contact.split(',');
    if(this.record.contact) {
      for (const contact of contacts) {
        this.timetable_link_uploaded().push(new FormControl(contact.split('/').pop()));
      }
    }    

  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }

  imagePreview(value) {

    this.imageLink = value;
    this.modalService.show(this.imagePreviewRef, { class: 'modal-lgs' });

  }


  onSubmit() {

    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

    this.projectService.addProject(this.createForm.value).subscribe(
      res => {

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();

          if (this.redirect1 == "") {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.PROJECT]);
              });
          }
          else {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.PROJECT]);
          });
          }
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }



  getData() {
  
    this.createFormErrorMsg = {
      'code': [{ type: 'required', message: this.lang.requiredField }],
      'title': [{ type: 'required', message: this.lang.requiredField }],
      'customer_id': [{ type: 'required', message: this.lang.requiredField }],
      'emp_id': [{ type: 'required', message: this.lang.requiredField }],
      'amount': [{ type: 'required', message: this.lang.requiredField }],
      'hours': [{ type: 'required', message: this.lang.requiredField }],
      'start_date': [{ type: 'required', message: this.lang.requiredField }],
      'd_date': [{ type: 'required', message: this.lang.requiredField }],
      'offer': [{ type: 'required', message: this.lang.requiredField }],
      'contact': [{ type: 'required', message: this.lang.requiredField }],
      'class_id': [{ type: 'required', message: this.lang.requiredField }],
      'class_category': [{ type: 'required', message: this.lang.requiredField }],
    }

  }


}
